import { z } from 'zod'

export const account = z.object({
    id: z.string(),
    name: z.string(),
})
